import React, { useState, useEffect, useRef } from 'react'

import LazyLoad from 'react-lazy-load'
import { useSelector, shallowEqual } from 'react-redux'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'

import { SimpleCarousel } from '.'
import { BreadCrumbs } from '..'
import { useEventListener, useWindowSize } from '../../_helpers'
import {
    Container,
    Meta,
    devices,
    colors,
} from '../Common'
import { Loading } from '../Global/Loading'

const ImageCard = ({ image, openModal, index, width, mobile }) => {
    const columns = mobile ? 2 : 3
    const thumbWidth = Math.round((width / columns) - 23)
    const [height, setHeight] = useState(0)
    const [opacity, setOpacity] = useState(0)

    let img = new Image()
    img.src = image.image
    img.onload = () => setHeight((img.height / img.width) * thumbWidth)

    useEffect(() => {
        if (height > 0) setTimeout(() => setOpacity(1), 500)
    }, [height])

    return (
        <ImageContainer opacity={opacity} height={height} src={image.image} alt={image.alt_text} once>
            <ImageHover onClick={openModal}>
                <HoverText>
                    <div>{index + 1}</div>
                    {image.description || 'Description'}
                </HoverText>
            </ImageHover>
        </ImageContainer>
    )
}


const PageView = () => {
    const { page, notFound } = useSelector(state => state.content, shallowEqual)
    const { gallery, title } = page

    const [showLightBox, setShowLightBox] = useState(false)
    const [activeSlide, setactiveSlide] = useState(0)
    const { width } = useWindowSize()
    const mobile = width < 480
    const container = useRef()
    const [containerWidth, setContainerWidth] = useState('')

    const openModal = i => {
        setactiveSlide(i)
        window.scrollTo(0, 0)
        document.getElementById('main').scrollTop = 0
        setShowLightBox(true)
    }

    const closeModal = () => setShowLightBox(false)
    useEffect(closeModal, [page])

    if (notFound) return <Redirect to='/' />

    useEffect(() => {
        if (container) setContainerWidth(container.current.offsetWidth)
    }, [container])

    useEventListener('resize', () => setContainerWidth(container.current.offsetWidth))

    return (
        <>
            <Meta page={page} />
            <PageContainer ref={container} lightbox={showLightBox}>
                {gallery ?
                    showLightBox ?
                        <SimpleCarousel slides={gallery} close={closeModal} activeImage={activeSlide} title={title} mobile={mobile} />
                        :
                        <>
                            {title && <BreadCrumbs title={title} mobile={mobile} />}
                            <ImageList>
                                {gallery.map((image, i) =>
                                    <ImageCard
                                        key={i}
                                        image={image}
                                        index={i}
                                        width={containerWidth}
                                        openModal={() => openModal(i)}
                                        mobile={mobile}
                                    />
                                )}
                            </ImageList>
                        </>
                    : <Loading marginbottom={30} />}
            </PageContainer>
        </>
    )
}

const PageContainer = styled(Container)`
    ${({ lightbox }) => lightbox && `
        padding-left: 0;
        padding-right: 0;
    `}

    min-height: calc(100vh - 90px);
    @media ${devices.small} {
        min-height: 95vh;
    }
`

const ImageList = styled.div`
   column-count: 3;
   column-gap: 6px;

    @media ${devices.small} {
        column-count: 2;
        column-gap: 6px;
    }
`

const ImageHover = styled.div`
    height: 100%;
    cursor: pointer;
    background: ${colors.red};
    color: ${colors.white};
    transition: opacity 0.2s ease-in;
    opacity: 0;
    position: relative;

    &:hover {
        opacity: 1;
    }

    @media ${devices.small} {
        opacity: 1;
        background: transparent;
        text-shadow: 0 1px 1px #000000;
    }
`

const HoverText = styled.div`
    position: absolute;
    bottom: 7px;
    left: 7px;
    font-size: 13px;
    font-family: pragmatica-extended, sans-serif;
    font-weight: 400;
    font-style: normal;

    div {
        font-weight: 900;
        margin-bottom: 3px;
        font-size: 16px;
        @media ${devices.small} {
            font-size: 13px;
        }
    }

    @media ${devices.small} {
        font-size: 11px;
    }

`

const ImageContainer = styled(LazyLoad)`
    width: calc(100% - 18px);
    margin-bottom: 10px;
    transition: opacity 0.3s ease-in;
    opacity: ${props => props.opacity};
    border: 7px solid white;
    background: url(${props => props.src}) center/cover no-repeat;
    /* -webkit-column-break-inside: avoid; */
    page-break-inside: avoid;
    break-inside: avoid;
    display: inline-block;

    @media ${devices.small} {
        border-width: 3px;
        width: calc(100% - 9px);
        /* margin-bottom: 5px; */
    }
`

export default PageView
